import React from "react";
import { Navigate } from "react-router-dom";

const PdfSearchPage = () => <Navigate to="/BancodeDados?tab=documentos" replace />;

export default PdfSearchPage;
